import React, { createContext, useContext, ReactNode } from "react";

export interface IContentStepperContext {
  activeStep: number;
  setActiveStep: (step: number) => void;
  goNext: () => void;
  goPrevious: () => void;
  direction: "left" | "right";
  totalSteps: number;
}

const ContentStepperContext = createContext<IContentStepperContext | undefined>(
  undefined
);

export interface IContentWizardContextProvider {
  children: ReactNode;
  value: IContentStepperContext;
}

export const ContentStepperContextProvider: React.FC<
  IContentWizardContextProvider
> = ({ children, value }) => {
  return (
    <ContentStepperContext.Provider value={value}>
      {children}
    </ContentStepperContext.Provider>
  );
};

export const useContentStepperContext = (): IContentStepperContext => {
  const context = useContext(ContentStepperContext);

  if (context === undefined) {
    throw new Error(
      "useContentWizardContext must be used within a ContentWizardContextProvider"
    );
  }

  return context;
};
